import { render, staticRenderFns } from "./DescontosTabela.vue?vue&type=template&id=2bebfb36&scoped=true"
import script from "./DescontosTabela.vue?vue&type=script&lang=js"
export * from "./DescontosTabela.vue?vue&type=script&lang=js"
import style0 from "./DescontosTabela.vue?vue&type=style&index=0&id=2bebfb36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bebfb36",
  null
  
)

export default component.exports